'use strict';
const trackingUtils = require('od-modules/utils/tracking.utils');
const recaptchaManager = require('od-modules/users/recaptcha.js');
const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const withCachedSelectors = require('components-framework/view/with_cached_selectors');

module.exports = withRenderedMain(withCachedSelectors(BaseView.extend({
    events: {
        'tap .freq_pass_newBtn': 'goToTappedNewPassenger',
        'tap .freq_pass_edit': 'goToTappedPassenger',
        'tap .loginexpired_login_button': 'login',
        'keyup .user_login': 'keyPressed',
        'tap .password_icon': 'changePasswordCharsViewer',
        'tap .close_session': 'closeSession',
        'focus .prisma_input_group': 'onFocusInput',
        'blur .prisma_input_group': 'onBlurInput',
    },

    selectors: {
        allInputs: '.login_user_with_password [data-name]:not([type="hidden"])',
        passwordInput: '.loginexpired_password_input',
        loginUserWithPassword: '.login_user_with_password',
        passwordIcon: '.password_icon',
        rememberLogout: '.remember_logout',
        loginUserWithSocial: '.login_user_with_social',
        loginUserWithGoogle: '.login_user_with_google',
        loginUserWithFacebook: '.login_user_with_facebook',
        welcomeBack: '.welcome_back',
        welcomeBackTemplate: '.welcome_back_template',
        loginExpiredWaiting: '.loginexpired_waiting',
        loginExpiredError: '.login_expired_error',
        recaptchaWrapper: '.g_recaptcha_login_expired',
        prismaInput: '.prisma_input_group',
    },

    initialize: function() {
        this.options = {
            recaptchaLoginEnabled: Odigeo.AB.isRecaptchaLoginEnabled,
            recaptchaSiteKey: Odigeo.UserArea.recaptchaSiteKey,
        };
        this.bindToDom();
        this.renderRememberLogout();
        this.loadloginForm();

        if (this.options.recaptchaLoginEnabled) {
            if (recaptchaManager.isGRecaptchaLoaded) {
                this.renderCaptcha();
            } else {
                recaptchaManager.init();
            }
        }
    },

    renderCaptcha: function() {
        if (this.options.recaptchaLoginEnabled && !this.model.get('recaptchaRendered')) {
            this.model.set('recaptchaWidgetID', recaptchaManager.gRecaptchaRender(this.$cachedSelectors.recaptchaWrapper.get(0),
                Odigeo._.bind(this.recaptchaExecutionCallback, this), this.options.recaptchaSiteKey));
            this.model.set('recaptchaRendered', true);
        }
    },

    recaptchaExecutionCallback: function() {
        this.model.data.recaptchaResponse = recaptchaManager.gRecaptchaGetResponse(this.model.get('recaptchaWidgetID'));
        this.triggerSubmitRequest();
    },

    loadloginForm: function() {
        const typeLogin = this.model.typeLogin;
        const showLoginForm = Odigeo._.bind(function(social, typeLogin) {
            this.$cachedSelectors.loginExpiredWaiting.addClass('odf-hidden').removeClass('active');
            this.$cachedSelectors.loginUserWithPassword.toggleClass('odf-hidden', social);
            this.$cachedSelectors.loginUserWithSocial.toggleClass('odf-hidden', !social);
            this.$cachedSelectors.loginUserWithGoogle.toggleClass('odf-hidden', !(social && typeLogin === 'google'));
            this.$cachedSelectors.loginUserWithFacebook.toggleClass('odf-hidden', !(social && typeLogin === 'facebook'));
        }, this);
        const isSocialLogin = this.$cachedSelectors.welcomeBack.length > 0 && Odigeo._.includes(['facebook', 'google'], typeLogin);
        if (isSocialLogin) {
            Odigeo.trigger(this.id + ':initEmbedLogin', typeLogin);
            const welcomeBackMessage = Odigeo.Utils.replaceCmsKeyArgs(this.keys.welcomeBack, this.model.name);
            this.$cachedSelectors.welcomeBack.empty().append(welcomeBackMessage);
            Odigeo.Session.set('socialLoginExpired', true);
        }
        showLoginForm(isSocialLogin, typeLogin);
    },

    bindToDom() {
        this.$el.on('input', this.selectors.passwordInput, Odigeo._.bind(this.showPasswordCharsIcon, this));
    },

    onFocusInput: function(e) {
        $(e.target).closest(this.selectors.prismaInput).addClass('focused');
    },

    onBlurInput: function(e) {
        $(e.target).closest(this.selectors.prismaInput).removeClass('focused');
    },

    renderRememberLogout: function() {
        const notName = Odigeo.Utils.replaceCmsKeyArgs(this.keys.notName, this.model.name);
        const {logout} = this.keys;
        this.$cachedSelectors.rememberLogout.empty().append(this.templates.rememberMe({
            keys: {notName, logout},
        }));
    },

    keyPressed: Odigeo._.debounce(function(e) {
        if ((e.keyCode ? e.keyCode : e.which) === 13) {
            this.login();
        }
    }, 300),

    login: function() {
        this.$cachedSelectors.passwordInput.closest('.input_wrapper').removeClass('invalid');
        if (this.checkPassword()) {
            trackingUtils.trackEventWithCategory('sso_expired', 'sign_in', 'sign_in');
            this.model.data = {
                login: this.model.mail,
                password: this.$cachedSelectors.passwordInput.val(),
            };
            this.hideGenericError();
            if (this.options.recaptchaLoginEnabled && this.model.get('recaptchaRendered')) {
                recaptchaManager.gRecaptchaExecute(this.model.get('recaptchaWidgetID'));
            } else {
                this.triggerSubmitRequest();
            }
        }
    },

    triggerSubmitRequest: function() {
        Odigeo.trigger(this.id + ':submitUserRequest', {'data': this.model.data, 'action': 'login'});
    },

    checkPassword: function() {
        var errorLog;
        var value = this.$cachedSelectors.passwordInput.val();
        var valData = this.$cachedSelectors.passwordInput.data();
        var isEmpty = false;

        if (Odigeo._.isEmpty(value)) {
            errorLog = 'empty';
        } else if (valData && valData.validationType && !Odigeo.Utils.isValid(valData.validationType, value)) {
            errorLog = 'invalid';
        } else {
            isEmpty = true;
        }

        if (!isEmpty) {
            this._showError(errorLog);
        }
        return isEmpty;
    },

    launchAccountBlockedFlow: function() {
        Odigeo.Utils.eraseCookie('sso_remember_me');
        Odigeo.trigger(this.id + ':submitUserRequest', {
            data: this.model.mail,
            action: 'recoverPassword',
        });
        Odigeo.Router.navigate('accountblocked');
    },

    changePasswordCharsViewer: function() {
        this.$cachedSelectors.passwordIcon.find('.password_char_viewer').toggleClass('odf-hidden');
        this.$cachedSelectors.passwordInput.attr('type',
            this.$cachedSelectors.passwordInput.attr('type') === 'password' ? 'text' : 'password'
        );
    },

    showPasswordCharsIcon: function() {
        this.$cachedSelectors.passwordIcon.removeClass('odf-hidden');
        this.$el.off('input', this.selectors.passwordInput);
    },

    closeSession: function() {
        this.$cachedSelectors.loginUserWithPassword.addClass('odf-hidden');
        this.$cachedSelectors.loginUserWithSocial.addClass('odf-hidden');
        this.$cachedSelectors.loginExpiredWaiting.addClass('active').removeClass('odf-hidden');
        trackingUtils.trackEventWithCategory('sso_module', 'sign_in', 'close_session_clicks');
        Odigeo.Utils.eraseCookie('sso_remember_me');
        Odigeo.Session.set('dontDisplayGoogleOneTap', true);
        Odigeo.Utils.goToApplicationHome();
    },

    _showError: function(error) {
        if (this.options.recaptchaLoginEnabled) {
            recaptchaManager.gRecaptchaReset(this.model.get('recaptchaWidgetID'));
        }
        var errText;
        var $inputWrapper = this.$cachedSelectors.passwordInput.closest('.input_wrapper');

        error = (Odigeo._.isUndefined(error)) ? 'requesterror' : error;
        if (error.indexOf('recaptcha') !== -1) {
            this.showGenericError('recaptchaerror');
            trackingUtils.trackEventWithCategory(Odigeo.Utils.isHomePage() ? 'home' : Odigeo.History.getPageNameFromFragment(),
                'recaptcha_error', 'odigeo_recaptcha_error_sign-on');
        } else if (error === 'remoteError') {
            this.showGenericError('remoteerror');
        } else {
            errText = this.$cachedSelectors.passwordInput.data(error);
            if (error === 'invalid') {
                trackingUtils.trackEventWithCategory('sso_expired', 'sign_in', 'sso_email_pci_compliance_error');
            }
            $inputWrapper.addClass('invalid');
            $inputWrapper.find('.error_message').text(errText);
        }
    },

    showGenericError: function(errAttr) {
        var err = this.$cachedSelectors.loginExpiredError.data(errAttr);
        this.$cachedSelectors.loginExpiredError.find('.msg_content').text(err);
        this.$cachedSelectors.loginExpiredError.removeClass('odf-hidden');
    },

    hideGenericError: function() {
        this.$cachedSelectors.loginExpiredError.addClass('odf-hidden');
    },

    _tracktEvent: function(action, label, category) {
        // Analytics: event tracking
        trackingUtils.trackEventWithCategory(category, action, label);
    },

    _isAccountBlocked: function(data) {
        return data && data.messageError && this.model.errors[data.messageError] === 'accountblocked';
    },
})));
